import React from "react";
import { Panel } from "../../components/panels";
import LinkedShows from "./LinkedShows";
import { ButtonSecondary } from "components/Atoms/Button";

interface Props {
  linkedShowsPanel: server.dto.LinkedShowPanel
  documentType: server.dto.DocumentTypes
  defaultBookkeeping: server.dto.BookkeepingSmall
  onShowsChange?: (shows: server.dto.ShowForListInternal[]) => void;
}

const LinkShowApp = (props: Props) => {
  const { linkedShowsPanel } = props;
  const [isLinkModalOpen, setIsLinkModalOpen] = React.useState<boolean>(false);


  const linkButton = (props.linkedShowsPanel.config.canLinkUnlink)
    ? <ButtonSecondary onClick={() => { setIsLinkModalOpen(true); }} label={RESX.GeneralLabels.Link} />
    : null;

  return (<Panel
    panelClassName="s1_related-feature-panel"
    title={site.currentEnvironment.show.plural}
    button={linkButton}
  >
    <LinkedShows
      documentType={props.documentType}
      onDisplayLinkShowsModalToggled={() => { setIsLinkModalOpen(!isLinkModalOpen); }}
      displayLinkShowsModal={isLinkModalOpen}
      queryKey={["linked-shows"]}
      initialShowCount={linkedShowsPanel.data.collection.length}

      config={linkedShowsPanel.config}
      defaultBookkeeping={props.defaultBookkeeping}
      onShowsChange={props.onShowsChange}
    />
  </Panel>);
};

export default LinkShowApp;